var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{ info_i2: _vm.newValue.empty, empty: _vm.newValue.empty }},[_vm._v(_vm._s(_vm.newValue.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }